import { render, staticRenderFns } from "./PackMaterialSubClass.vue?vue&type=template&id=2e770343&scoped=true&"
import script from "./PackMaterialSubClass.vue?vue&type=script&lang=js&"
export * from "./PackMaterialSubClass.vue?vue&type=script&lang=js&"
import style0 from "./PackMaterialSubClass.vue?vue&type=style&index=0&id=2e770343&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e770343",
  null
  
)

export default component.exports